<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/TDC/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>
